export const socialsData = {
    github: 'https://github.com/LovkashGarg',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/lovkashgarg/',
    instagram: 'https://www.instagram.com/aggarwal_lovkash10212/',
    twitter: 'https://x.com/GargLovkash',
    leetcode:'https://leetcode.com/u/Lovkash_2905/'
}